import { render, staticRenderFns } from "./SingleSifraTarife.vue?vue&type=template&id=5a5186f7"
import script from "./SingleSifraTarife.vue?vue&type=script&lang=js"
export * from "./SingleSifraTarife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports